import {
  format as formatDate,
  formatDistance,
  formatRelative,
  isDate,
} from "date-fns";
import { InitOptions } from "i18next";
import { LxLocale } from "../..";
import { lxI18NDateFnLocale } from "./lx-i18n-date-fn-locale";

// NOTE: dont use `resources`. This will disable
// the default `lx-i18n-backend` backend.
export function lxI18NOptions(language: LxLocale): InitOptions {
  return {
    lng: language,
    debug: false,
    fallbackLng: {
      "de-DE": ["de", "dev"],
      "en-GB": ["en", "dev"],
      "en-US": ["en", "dev"],
      default: ["dev"],
    },
    defaultNS: "lxo-common",
    keySeparator: false,
    interpolation: {
      escapeValue: false, // react already safes from xss
      format: (
        value: any,
        format: string | undefined,
        lng: string | undefined
      ) => {
        if (isDate(value) && format !== undefined) {
          const dateFnLocale = lxI18NDateFnLocale((lng as LxLocale) || "de-DE");
          switch (format) {
            case "short":
              return formatDate(value, "Pp", { locale: dateFnLocale });
            case "long":
              return formatDate(value, "PPPPpp", { locale: dateFnLocale });
            case "relative":
              return formatRelative(value, new Date(), {
                locale: dateFnLocale,
              });
            case "ago":
              return formatDistance(value, new Date(), {
                locale: dateFnLocale,
                addSuffix: true,
              });
            default:
              return formatDate(value, format, { locale: dateFnLocale });
          }
        }
        return value;
      },
    },
  };
}
